import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { A } from 'components/common/Link/Link'

const ActiveVehicle = ({
  noOfVehicles,
  userVehicle: [{
    tireFrontSize,
    tireRearSize,
    vehicleNickname
  } = {}],
  addNewVehicle
}) =>
  <VehicleSection>
    { noOfVehicles ?
      <Fragment>
        <VehicleName>{ vehicleNickname }</VehicleName>
        {
          tireFrontSize &&
            <VehicleTireSizes>
              <TireSizeTitle>Tire Size:</TireSizeTitle>
              { tireRearSize && <TireSize>Front:</TireSize> }
              { tireFrontSize }
              { tireRearSize && <TireSize>Rear:</TireSize> }
              { tireRearSize }
            </VehicleTireSizes>
        }
      </Fragment> :
      <SelectVehicle
        prevent
        handler={ addNewVehicle }>Select Vehicle</SelectVehicle>
    }
  </VehicleSection>

ActiveVehicle.propTypes = {
  addNewVehicle: PropTypes.func,
  noOfVehicles: PropTypes.number,
  userVehicle: PropTypes.arrayOf(PropTypes.shape())
}

export default ActiveVehicle

const VehicleSection = styled.div`
  margin: 20px 16px;
  vertical-align: bottom;
`

const VehicleName = styled.span`
  font-weight: 700;
  text-transform: capitalize;
  ${Mixin.responsive('font-size', '21px', '18px')}
  ${Media.desktop`
    margin-right: 20px;
  `}
  ${Media.mobile`
    display: block;
  `}
`

const VehicleTireSizes = styled.span`
  font-weight: 600;
  ${Mixin.responsive('font-size', '19px', '14px')}
  ${Media.mobile`
    margin-top: 5px;
    display: inline-block;
  `}
`

const TireSizeTitle = styled.span`
  font-size: inherit;
  margin-right: 3px;
`

const TireSize = styled.span`
  font-size: inherit;
  font-weight: 700;
  margin: 0 5px;
`

const SelectVehicle = styled(A)`
  font-weight: 600;
  ${Mixin.responsive('font-size', '19px', '14px')}
`
